(() => {
  if (window.__sqmHscroll) return;
  window.__sqmHscroll = true;

  const init = (root) => {
    if (root.dataset.hscrollReady === 'true') return;
    const track = root.querySelector('[data-hscroll-track]');
    const prev = root.querySelector('[data-hscroll-prev]');
    const next = root.querySelector('[data-hscroll-next]');
    if (!track || !prev || !next) return;

    root.dataset.hscrollReady = 'true';
    const itemSelector = root.dataset.hscrollItem || ':scope > *';

    const sync = () => {
      const overflowing = track.scrollWidth > track.clientWidth + 1;
      prev.hidden = !overflowing;
      next.hidden = !overflowing;
      if (!overflowing) return;

      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    };

    const nudge = (direction) => {
      const item = track.querySelector(itemSelector);
      const gap =
        parseFloat(getComputedStyle(track).columnGap) ||
        parseFloat(getComputedStyle(track).gap) ||
        0;
      const step = item
        ? (item.getBoundingClientRect().width + gap) * 2
        : track.clientWidth * 0.8;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * step, behavior: reduce ? 'auto' : 'smooth' });
    };

    sync();
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    prev.addEventListener('click', () => nudge(-1));
    next.addEventListener('click', () => nudge(1));
  };

  const scan = (scope = document) => {
    scope.querySelectorAll('[data-hscroll]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });
})();
